import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BotIdContext = createContext();

export const useBotId = () => {
  const context = useContext(BotIdContext);
  if (!context) {
    throw new Error('useBotId must be used within a BotIdProvider');
  }
  return context;
};

export const BotIdProvider = ({ children }) => {
  const [botId, setBotId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Extract bot_id from URL query string
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('bot_id');
    if (id) {
      setBotId(id);
    }
  }, [location.search]);

  const value = {
    botId,
    setBotId
  };

  return (
    <BotIdContext.Provider value={value}>
      {children}
    </BotIdContext.Provider>
  );
};

